export function formatDate(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export function makeTree(list) {
  var ret = list.filter(e => { return e.parentId == 0 })
  var nlist = ret
  while (nlist.length > 0) {
    var nn = []
    for (var i = 0; i < nlist.length; i++) {
      var item = nlist[i]
      item.children = list.filter(e => { return e.parentId == item.id })
      if (item.children.length > 0) {
        nn = nn.concat(item.children)
      }
      else {
        delete item.children
      }
    }
    nlist = nn
  }
  return ret
}